import React from 'react';
// template components
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import hostImage from './images/host-headshot-photo.webp';
// styles
import {
  ColStyledContentContainer,
  ColStyledImageContainer,
  PictureStyled,
  TypographyStyledHeading,
} from './styles';

export default () => {
  return (
    <SectionContainer
      id='podcast-get-to-know-your-host'
      backgroundVariant='darkDefault'
      themeType='darkTheme'>
      <Row align='center'>
        <ColStyledImageContainer
          align='center'
          medium={4}
          large={3}>
          <PictureStyled
            variant='round'
            src={hostImage}
            altText='Podcast host'
          />
        </ColStyledImageContainer>
        <ColStyledContentContainer
          medium={8}
          large={9}>
          <TypographyStyledHeading
            component='h2'
            themeType='darkTheme'
            nextElement='typography'>
            Get to know your <WidowBlock>podcast host.</WidowBlock>
          </TypographyStyledHeading>
          <Typography
            themeType='darkTheme'
            disableBottomPadding>
            Jennifer Borget is a former broadcast journalist turned award&#45;winning digital creator, celebrated for her compelling storytelling. As a mom of three, she and her husband are navigating the everyday complexities of balancing money with their busy life&#8212;learning along the way. Through her work, Jennifer inspires families to live each day with gratitude and make the most of every day.
          </Typography>
        </ColStyledContentContainer>
      </Row>
    </SectionContainer>
  );
};
